import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLayout from '../components/LegalPageLayout';
import { useSiteSettings } from '../context/SiteSettingsContext';

const Returns = () => {
  const { t } = useTranslation();
  const { returnsEnabled, returnsWindowDays } = useSiteSettings();

  const notice = returnsEnabled ? (
    <div className="legal-notice">
      {t('returns.windowNotice', { days: returnsWindowDays })}
    </div>
  ) : (
    <div className="legal-notice legal-notice--muted">
      {t('returns.disabledNotice')}
    </div>
  );

  return <LegalPageLayout namespace="returns" sectionCount={6} extra={notice} />;
};

export default Returns;
